export const actions = {
  set_state: 'gtm_product/set_state',
  get_gtm_product: 'gtm_product/get',
  get_gtm_product_qr: 'gtm_product/get_gtm_product_qr',
  delete_gtm_product: 'gtm_product/delete',
  create_gtm_product: 'gtm_product/create'
}
